import { GetUserCampaignStats, JoinCampaign } from 'api/coinlocally/v1/campaign';
import { ICampaignApiService } from './services.entity';

class CampaignApiService implements ICampaignApiService {
	campaignName: TCampaignName;
	constructor(campaignName: TCampaignName) {
		this.campaignName = campaignName;
	}
	JoinCampaign(): Promise<boolean> {
		return JoinCampaign(this.campaignName);
	}
	GetUserCampaignStats(): Promise<ICampaignStats> {
		return GetUserCampaignStats(this.campaignName);
	}
}
//TODO: make a factory and move to other place
const campaignApiService = new CampaignApiService('Competition2025');

export default campaignApiService;
